// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { selectLanguage, SetLanguage } from '@med/app/core/language/store';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { ConfigService } from '@med/app/core/config/config.service';

declare let require: any;

@Injectable({
  providedIn: 'root',
})
export class LanguageService {

  private readonly localStorageKey = 'language';
  private readonly availableLanguages = this.configService.getConfig().languages;
  private initDone = false;

  constructor(
    private store: Store,
    private translate: TranslateService,
    private configService: ConfigService,
  ) {

  }

  public initLanguage(): void {
    if (this.initDone) {
      return;
    }

    this.initTranslator();
    this.initAppLanguage();
    this.initDone = true;
  }

  public setLanguage(language: string): void {
    this.verifyLanguage(language);
    this.saveLanguage(language);
    this.store.dispatch(new SetLanguage({language}));
  }

  public saveLanguage(language: string): void {
    this.verifyLanguage(language);
    localStorage.setItem(this.localStorageKey, language);
  }

  public getLanguage(): Observable<string> {
    return this.store.pipe(select(selectLanguage));
  }

  private initTranslator(): void {
    this.store.pipe(
      select(selectLanguage),
      filter(value => !!value),
    ).subscribe(language => {
      this.translate.setDefaultLang(language);
      this.translate.addLangs(this.availableLanguages);

      // 'require' puts the JSON contents into a chunk with cache breaker
      // the .use method does not support this
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      this.translate.setTranslation(language, require(`./../../../../assets/i18n/${ language }.json`));
      this.translate.use(language);
    });

  }

  private initAppLanguage(): void {
    let language = localStorage.getItem(this.localStorageKey);
    if (!language || !this.availableLanguages.includes(language)) {
      language = this.availableLanguages.slice().shift();
    }

    this.setLanguage(language);
  }

  private verifyLanguage(language: string): void {
    if (!this.availableLanguages.includes(language)) {
      throw new Error(`Cannot use language: ${ language }`);
    }
  }

}
